// extracted by mini-css-extract-plugin
module.exports = {"detail":"EditableTime_detail__1Al8S","label":"EditableTime_label__2QUWM","value":"EditableTime_value__14_NH"};